import React from 'react'
import Icon from './Icons/Close'

export default (props) => (
  <button {...props}>
    <Icon />
  </button>
)



// WEBPACK FOOTER //
// ./src/components/CloseButton.jsx